"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Year = exports.Month = exports.Week = exports.RecurringTimeUnit = void 0;
var TimeUnit;
(function (TimeUnit) {
    TimeUnit["WEEK"] = "Week";
    TimeUnit["MONTH"] = "Month";
    TimeUnit["YEAR"] = "Year";
})(TimeUnit || (TimeUnit = {}));
class RecurringTimeUnit {
    constructor(nUnits, timeUnit) {
        this.nUnits = 0;
        this.timeUnit = '';
        if (nUnits <= 0 || !Number.isInteger(nUnits)) {
            console.error(`${nUnits} ${timeUnit} is not a valid time duration`);
        }
        else {
            this.nUnits = nUnits;
            this.timeUnit = timeUnit;
        }
    }
    toString() {
        if (!this.nUnits || !this.timeUnit) {
            return '';
        }
        return `${this.nUnits} ${this.timeUnit}`;
    }
}
exports.RecurringTimeUnit = RecurringTimeUnit;
/* tslint:disable:max-classes-per-file */
class Week extends RecurringTimeUnit {
    constructor(nWeeks) {
        super(nWeeks, TimeUnit.WEEK);
    }
}
exports.Week = Week;
/* tslint:disable:max-classes-per-file */
class Month extends RecurringTimeUnit {
    constructor(nMonths) {
        super(nMonths, TimeUnit.MONTH);
    }
}
exports.Month = Month;
/* tslint:disable:max-classes-per-file */
class Year extends RecurringTimeUnit {
    constructor(nYears) {
        super(nYears, TimeUnit.YEAR);
    }
}
exports.Year = Year;
